import React from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
    display: flex;
    align-items: center;

    li{
        font-size:0.9rem;
        font-family: "Poppins";
        font-weight: 600;
        cursor: pointer;
        list-style: none;
        margin-right: 1.2rem;
    }

`

const Pagination = ({selectItems}) => {
    return (

        <CardWrapper>
            <li>01</li>

            <li>
                <a href="#top">
                <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2498 11.9308C19.4257 11.7549 19.5917 11.7549 19.748 11.9308L23.1478 15.3305C23.3236 15.4868 23.3236 15.6431 23.1478 15.7994L19.748 19.1992C19.5917 19.375 19.4257 19.375 19.2498 19.1992L19.0447 18.994C18.8688 18.8377 18.8688 18.6716 19.0447 18.4958L21.5065 16.0632H10.4867C10.2522 16.0632 10.135 15.946 10.135 15.7115V15.4184C10.135 15.184 10.2522 15.0667 10.4867 15.0667H21.5065L19.0447 12.6342C18.8688 12.4583 18.8688 12.2922 19.0447 12.1359L19.2498 11.9308Z" fill="#888888" />
                </svg>
                </a>
            </li>

        </CardWrapper>


    )
}

export default Pagination